module.exports = __webpack_public_path__ + "img/blimpy2.c18fbfae.jpg";